// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"import"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M9 3H3V21H21V10","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M21 4L17 4C14.2386 4 12 6.23857 12 9L12 14M15.5 12L12 15.5L8.5 12","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ImportIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'import',
    ref,
    icon: element,
  },
));

ImportIcon.displayName = 'ImportIcon';

export default ImportIcon;
